import { render, staticRenderFns } from "./VitalSignList.vue?vue&type=template&id=64974eff&"
import script from "./VitalSignList.vue?vue&type=script&lang=js&"
export * from "./VitalSignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports